import { professionsEndpoints } from "store/apis/professionsAPI/professions.api"

export const {
  useAbilityLevelUpMutation,
  useGetAllProfessionsQuery,
  useGetUserProfessionsQuery,
  useResetProfessionMutation,
  endpoints: { getAllProfessions, resetProfession }
} = professionsEndpoints
